export default {
  getBindSelectList: '/api/lp/noticeList/getBindSelectList', // 关联出库单 - 查询条件 - 列表
  queryRvNoticeList: '/api/lp/noticeList/queryRvNoticeList', // 关联 - 列表
  getStatusList: '/api/lp/noticeList/status',
  getPartner: '/api/noticeForIdb/getPartner',
};
